import { useEffect } from 'react'

import { useEventContext } from 'context/EventContext'
import detachTask from 'helpers/detachTask'
import uuidv4 from 'helpers/uuidv4'

// TODO: remove this is included now in the analytics package
const useDataEventListeners = enabled => {
  const { sendEvent } = useEventContext()
  useEffect(() => {
    const dataListener = event => {
      // id for client-side events, name for server-side events
      const { dataset } =
        event.target.closest('[data-evt-name]:not(.prevent-event)') ||
        event.target.closest('[data-evt-id]:not(.prevent-event)') ||
        {}

      if (!dataset) {
        return
      }

      const { evtId, evtFallback } = dataset

      let evtData = window.__GDM_EVENTS__?.[evtId]

      // send server-side event if no client-side event is found
      if (!evtData && evtFallback) {
        try {
          evtData = JSON.parse(atob(evtFallback))
        } catch (error) {
          console.error('Failed to decode server-side event fallback:', error)
          return
        }
      }

      if (!evtData) {
        return
      }
      // send client-side event if no server-side event is found
      if (evtData.name && evtData.name.includes('clickout')) {
        evtData.transactionId = uuidv4()
      }

      detachTask(sendEvent, { ...evtData, type: event.button || 0 })
    }

    window.addEventListener('mousedown', dataListener)

    return () => {
      window.removeEventListener('mousedown', dataListener)
    }
  }, [enabled, sendEvent])
}

export default useDataEventListeners
